<template>
  <div>
    <v-container class="grey lighten-5" fluid>
      <v-row v-if="pageDetails && Object.entries(pageDetails).length">
        <v-col cols="12">
          <h1>{{ pageDetails.category.name }} {{ pageDetails.city ? '/ ' + pageDetails.city.name : ''}}</h1>
          <v-tabs v-model="tab">
            <v-tab>
              Paragrafy
            </v-tab>
            <v-tab>
              Opinie
            </v-tab>
            <v-tab>
              Wykonane usługi
            </v-tab>
            <v-tab>
              Meta dane
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <p>Chcesz zmienić kolejność paragrafów? Złap i przeciągnij w górę/dół paragraf (złap za toolbar edytora lub z lewej strony edytora).</p>
                  <v-form>
                      <v-btn
                          @click="addParagraph"
                      >
                          Dodaj nowy paragraf
                      </v-btn>
                    <v-row>
                      <draggable v-model="draggableParagraphs">
                      <template v-for="(paragraph, index) in pageDetails.text.p">
                        <v-col cols="12" v-bind:key="index">
                          <ckeditor
                              :editor="editor"
                              v-model="pageDetails.text.p[index]"
                              :config="editorConfig"
                          ></ckeditor>
                        <span class="v-btn" @click="deleteParagraph(index)">Usuń paragraf</span>
                        </v-col>
                      </template>
                      </draggable>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-form>
                    <v-row>
                      <template v-for="(opinion, index) in pageDetails.opinions.o">
                        <v-col cols="12" v-bind:key="index">
                          <v-text-field v-model="pageDetails.opinions.o[index].author" class="col-2"></v-text-field>
                          <v-slider
                              v-model="pageDetails.opinions.o[index].rating"
                              label="Ocena"
                              thumb-label="always"
                              max="5"
                              min="1"
                              class="col-2"
                          ></v-slider>
                          <ckeditor
                              :editor="editor"
                              v-model="pageDetails.opinions.o[index].text"
                              :config="editorConfig"
                          ></ckeditor>
                          <hr class="mt-4"/>
                        </v-col>
                      </template>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-form>
                    <v-row>
                      <template v-for="(offer, index) in pageDetails.recentSales.o">
                        <v-col cols="12" v-bind:key="index">
                          <v-text-field v-model="pageDetails.recentSales.o[index].author" class="col-2"></v-text-field>
                          <v-text-field v-model="pageDetails.recentSales.o[index].category" class="col-2"></v-text-field>
                          <v-text-field v-model="pageDetails.recentSales.o[index].city" class="col-2"></v-text-field>
                          <v-text-field v-model="pageDetails.recentSales.o[index].quantity" class="col-2" type="number"></v-text-field>
                          <hr class="mt-4"/>
                        </v-col>
                      </template>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
                  <v-card>
                      <v-card-text>
                          <v-form>
                              <v-row>
                                  <v-col cols="12">
                                      <v-text-field v-model="pageDetails.title" class="col-6" label="Tytuł" hint="Tytuł"></v-text-field>
                                      <v-text-field v-model="pageDetails.description" class="col-12" label="Opis" hint="Opis"></v-text-field>
                                  </v-col>
                              </v-row>
                          </v-form>
                      </v-card-text>
                  </v-card>
          </v-tab-item>
          </v-tabs-items>
          <v-spacer/>
          <v-btn
              @click="savePageDetails"
          >
            Zapisz
            <v-icon size="24" right>
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <modal-loader :show="loading" />
  </div>
</template>

<script>
import api from '../services/api';
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import draggable from "vuedraggable";

export default {
  components: {
    ModalLoader,
    ckeditor: CKEditor.component,
    draggable,
  },
  mixins: [
    permissions,
  ],
  props: ['id'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        id: this.id,
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ],
        }
      },
      loading: false,
      loadingDetails: false,
      pageDetails: {},
      tab: null
    }
  },
  methods: {
    async loadDetails() {
      if (this.loadingDetails) {
        return;
      }

      this.loadingDetails = true;

      let response;

      try {
        response = await api.get(`/api/page-content/${this.id}`);
      } catch (error) {
        this.$root.$emit('notifyError', {
          html: 'Nie udało się wczytać danych strony.',
          error,
        });

        return;
      }

      this.loadingDetails = false;

      this.pageDetails = response.data;

        if (!this.pageDetails.text.p) {
            this.pageDetails.text = {p: [], m: []}
            this.pageDetails.text.p.push('');
        }
    },
    async savePageDetails() {
      this.loading = true;

      try {
        await api.put(`/api/page-content/${this.id}`, this.pageDetails);
      } catch (error) {
        /** @see https://github.com/axios/axios#handling-errors */
        this.loading = false;
        this.$root.$emit('notifyError', {
          html: 'Nie udało się zapisać danych strony.',
          error
        });

        return;
      }

      this.loading = false;
      this.$root.$emit('notifySuccess', {
        html: 'Dane strony zostały zapisane.'
      });
    },
    deleteParagraph(index) {
        this.pageDetails.text.p.splice(index, 1);
    },
    addParagraph() {
        this.pageDetails.text.p.push('');
    }
  },
  computed: {
    draggableParagraphs: {
      get() {
        return this.pageDetails.text.p
      },
      set(val) {
        this.pageDetails.text.p = val
      }
    }
  },
  async created() {
    try {
      await this.loadDetails();
    } catch (e) {
      void (0);
    }
  },
  beforeRouteUpdate(to, from, next) {
    next(); // Update the URL in address bar.
    this.id = to.params.id; // Store new user id in the local variable.
    this.loadDetails();
  },
}
</script>

<style scoped>
</style>
